import { render } from "./ProductCategorylist.vue?vue&type=template&id=1a4d584f&scoped=true"
import script from "./ProductCategorylist.vue?vue&type=script&lang=js"
export * from "./ProductCategorylist.vue?vue&type=script&lang=js"

import "./ProductCategorylist.vue?vue&type=style&index=0&id=1a4d584f&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4d584f"]])

export default __exports__